import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  width: 100%;
  padding: 15px 20px;
  background-color: #f8f9fa;
  text-align: center;
`;

const NavList = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding: 10px;
  margin: 0;
  
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const NavItem = styled.li`
  a {
    color: #505050;
    text-decoration: none;
    white-space: nowrap;
    font-size: 14px;
    
    &:hover {
      color: #007bff;
    }
  }
`;

const Tagline = styled.div`
  margin-top: 10px;
  font-style: italic;
  color: #505050;
  font-size: 14px;
  padding: 0 15px;
  line-height: 1.4;
`;

const FooterBar = () => {
  return (
    <FooterContainer>
      <NavList>
        <NavItem><Link to="/contact-us">Contact Us</Link></NavItem>
        <NavItem><Link to="/terms-condition">Terms & Conditions</Link></NavItem>
        <NavItem><Link to="/privacy-policy">Privacy Policy</Link></NavItem>
        <NavItem><Link to="/refund&cancellation">Refund & Cancellation</Link></NavItem>
        <NavItem><Link to="/delivery-policy">Delivery Policy</Link></NavItem>
        <NavItem><Link to="/business-model">Business Model</Link></NavItem>
        <NavItem><Link to="/services">Services</Link></NavItem>
      </NavList>
      <Tagline>
        © We Facilitate Neighbors To Buy and Sell Healthy Delicious Dishes With Price Ranging Between Rs2 and Rs500
      </Tagline>
    </FooterContainer>
  );
};

export default FooterBar;